<script>
import _ from 'lodash';
import { mapGetters, mapMutations } from 'vuex';
import {
  AdditionalDriversComponent,
  VehicleUserModule,
  VEHICLE_USER_TYPES,
  UserBadgeComponent,
  COMPONENT_EVENTS,
  algoliaHelpers,
} from '@/../refactor-dist/refactor-module';

import { VEHICLE_USER_MODULE } from '@/constants/modules';

const VEHICLE_USER_FILTER = {
  id: 'test',
  type: VEHICLE_USER_TYPES.driver,
};

const MAX_DRIVERS = 4;

export default {
  name: 'AdditionalDriversView',

  components: {
    AdditionalDriversComponent,
    UserBadgeComponent,
  },

  computed: {
    ...mapGetters(
      VEHICLE_USER_MODULE,
      {
        getVehicleUser: VehicleUserModule.GETTERS.data,
        getVehicleUserCount: VehicleUserModule.GETTERS.count,
      },
    ),

    additionalDrivers() {
      return this.getVehicleUser(VEHICLE_USER_FILTER);
    },

    countAdditionalDrivers() {
      return this.getVehicleUserCount(VEHICLE_USER_FILTER);
    },

    algoliaFilter() {
      const filter = algoliaHelpers.getAlgoliaFilterExcludingValues(
        'email',
        _.map(this.additionalDrivers, item => item.data),
      );

      return filter || '1!=1';
    },

    isDisabled() {
      return !(MAX_DRIVERS - this.countAdditionalDrivers);
    },
  },

  created() {
    this.EVENTS = COMPONENT_EVENTS;
  },

  methods: {
    ...mapMutations(
      VEHICLE_USER_MODULE,
      {
        addVehicleUser: VehicleUserModule.MUTATIONS.add,
        removeVehicleUser: VehicleUserModule.MUTATIONS.remove,
      },
    ),

    onAddAdditionalDriver(email) {
      this.addVehicleUser({
        ...VEHICLE_USER_FILTER,
        data: email,
      });
    },

    onRemoveAdditionalDriver(driver) {
      this.removeVehicleUser(driver);
    },
  },

};
</script>

<template>
  <div class="row">
    <div class="col-12 col-sm-8 col-md-6 col-xl-4">
      <AdditionalDriversComponent
        :algolia-filters="algoliaFilter"
        :disabled="isDisabled"
        algolia-index="employees"
        class="mb-3"
        v-on="{
          [EVENTS.change]: value => onAddAdditionalDriver(value)
        }"
      />
      <UserBadgeComponent
        v-for="(driver, index) in additionalDrivers"
        :key="`driver${index}`"
        :text="driver.data"
        class="mb-2 mr-2"
        v-on="{
          [EVENTS.remove]: () => onRemoveAdditionalDriver(driver),
        }"
      />
    </div>
  </div>
</template>
